import { render, staticRenderFns } from "./AddPlaceholderProduct.vue?vue&type=template&id=4944b117&"
import script from "./AddPlaceholderProduct.vue?vue&type=script&lang=js&"
export * from "./AddPlaceholderProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports